module.exports = __webpack_public_path__ + "media/application/images/svgs/copy-54039443afb442ff252f71498d936b6c.svg";